module.exports = __webpack_public_path__ + "static/media/Stationery-Mockup-LDMR.1de84518.jpg";